// node modules
import React from 'react';
import { observer } from 'mobx-react';
// modules
import { useStore } from 'modules/Stores';
import ReleaseNotesModal from 'modules/ReleaseNotes/components/ReleaseNotesModal';

const ReleaseNotesModalContainer = () => {
  const {
    modalsConfig: { releaseNotes },
  } = useStore('AppStore');

  return releaseNotes ? <ReleaseNotesModal /> : null;
};

export default observer(ReleaseNotesModalContainer);
